
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmRackPositionModel } from './rm-rack-position.model';

export class RmRackPositionResponseModel extends GlobalResponseObject {
    data?: RmRackPositionModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /RmRackPositionModel
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmRackPositionModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 